function getBaseUrl() {
    return window.location.protocol + '//' + window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
}

export default getBaseUrl;
